export const formatNumber = (value: number, lang: string): string =>
  new Intl.NumberFormat(lang).format(value);

export const formatCurrency = (value: number, currency: string, lang: string): string =>
  new Intl.NumberFormat(lang, { style: 'currency', currency }).format(value);

export const formatDate = (iso: string, lang: string): string =>
  new Date(`${iso}T00:00:00Z`).toLocaleDateString(lang, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'UTC',
  });

// Rounded to the one decimal the text shows, so the sign and the colour of a
// tiny change agree with the "0 %" on screen. `|| 0` turns -0 into 0.
export const deltaRatio = (current: number, previous: number): number | null =>
  previous ? Math.round(((current - previous) / previous) * 1000) / 1000 || 0 : null;

// "+8,3 %" against the previous period; no previous value means no ratio.
export const formatDelta = (current: number, previous: number, lang: string): string => {
  const ratio = deltaRatio(current, previous);
  if (ratio === null) return '–';
  const text = new Intl.NumberFormat(lang, { style: 'percent', maximumFractionDigits: 1 }).format(ratio);
  return ratio > 0 ? `+${text}` : text;
};

export const formatPercent = (ratio: number, lang: string): string =>
  new Intl.NumberFormat(lang, { style: 'percent', maximumFractionDigits: 1 }).format(ratio);
